import { render, staticRenderFns } from "./option.vue?vue&type=template&id=5678f108&"
import script from "./option.vue?vue&type=script&lang=js&"
export * from "./option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5678f108')) {
      api.createRecord('5678f108', component.options)
    } else {
      api.reload('5678f108', component.options)
    }
    module.hot.accept("./option.vue?vue&type=template&id=5678f108&", function () {
      api.rerender('5678f108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/option.vue"
export default component.exports